import React from 'react';

// Components
import FullScreenLoader from '../../components/FullScreenLoader/FullScreenLoader';

const LoadingPage = () => <FullScreenLoader />;

export default LoadingPage;
